<template>
    <div>
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-form-item label="关键字搜索:">
                    <el-input v-model="form.keyword" placeholder="请输入关键字"></el-input>
                </el-form-item>
                <el-button type="primary" @click="getListQuery">查询</el-button>
            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <router-link  :to="{ path:'/addScheduling',query:{callback:getList} }">
                    <el-button type="primary" v-w-role="'ITSM-0092'">新建</el-button>
                </router-link>
            </div>
            <el-table :data="tableData" v-loading="loading">
                <el-table-column type="index" width="50"/>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="名称" prop="title"></el-table-column>
                <el-table-column label="类型名称">
                    <template slot-scope="scope">
                        {{ scope.row.workType | tableVal(scheduling_work_type) }}
                    </template>
                </el-table-column>
                <el-table-column label="班次时间段1">
                    <template slot-scope="scope">
                        <span>{{scope.row.startTime1}}</span> - <span>{{scope.row.endTime1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="班次时间段2">
                    <template slot-scope="scope">
                        <span>{{scope.row.startTime2}}</span> - <span>{{scope.row.endTime2}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="两头班" prop="twoEnds">
                    <template slot-scope="scope">
                        <span>{{scope.row.twoEnds?'是':'否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="总时长">
                    <template slot-scope="scope">
                        <span>{{scope.row.totalTime}}小时</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/addScheduling',
                                            query:{type:'edit',message:scope.row.id,callback:getList} }">
                            <el-button type="text">修改</el-button>
                        </router-link>
                        <el-button v-w-role="'ITSM-0205'" class="table-del-btn" type="text" @click="deleteRole(scope.row.id)" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.pageIndex"
                :page-sizes="[10,20]"
                :page-size="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </el-card>
        
    </div>
</template>

<script>

    import services from './workforce.service.js';

    export default {
        data: function () {
            return {

                form:{//查询信息的参数
                    keyword:'',
                    pageIndex:1,
                    pageSize:10
                },
                tableData:[],
                total:5,
                loading:true,
            }
        },
        computed:{
            dictionary(){//业务字典
                return this.$store.state.dictionary;
            },
            scheduling_work_type(){//业务字典-类型名称
                return this.dictionary.scheduling_work_type;
            },
        },
        created(){
            this.getList();
        },
        methods:{
            getListQuery(){
                this.form.pageIndex = 1;
                this.getList();
            },
            getList(){//查询列表信息
                // this.tableData = [];
                // this.total = null;
                // this.loading = true;
                services.schedulingList(this.form).then(res=>{
                    this.tableData = res.list;
                    this.total = res.total;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            deleteRole(id){//删除信息
                this.openMessage('您确定要删除吗？', '确定', () => {
                    services.delScheduling({"id":id}).then(res => {
                        this.$message.success("成功删除!");
                        this.getList();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
            handleSizeChange(val){
                let pages = Math.ceil(this.total / val);
                this.form.pageSize = val;
                if(this.form.pageIndex > pages ){
                    this.form.pageIndex  = 1;
                };
                this.getList();
            },
            handleCurrentChange(val){
                this.form.pageIndex = val;
                this.getList();
            }
        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    
</style>
